export default __webpack_public_path__ + "static/images/b3.8834bd4.jpg";